var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBtnWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.179,
    height: 108.179,
    viewBox: "0 0 108.179 108.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CLOSE",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_794",
    "data-name": "Ellipse 794",
    transform: "translate(8.554 8.465)",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 48.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8600",
    "data-name": "Path 8600",
    d: "M52.8,46.939l-13.7-13.7,13.7-13.7a4.156,4.156,0,1,0-5.877-5.877l-13.7,13.7-13.7-13.7a3.976,3.976,0,0,0-5.877,0,4.015,4.015,0,0,0,0,5.877l13.7,13.7-13.7,13.7a4.018,4.018,0,0,0,0,5.877,4.128,4.128,0,0,0,5.877,0l13.7-13.7,13.7,13.7a4.175,4.175,0,0,0,5.877,0A4.128,4.128,0,0,0,52.8,46.939Z",
    transform: "translate(24.244 24.23)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8601",
    "data-name": "Path 8601",
    d: "M57.465,10.656a46.816,46.816,0,0,1,33.1,79.912A46.816,46.816,0,0,1,24.361,24.361a46.5,46.5,0,0,1,33.1-13.7m0-7.281a54.09,54.09,0,1,0,54.09,54.09,54.081,54.081,0,0,0-54.09-54.09Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtnWithBg);
export default __webpack_public_path__ + "static/media/closeBtn_withBg.42b5b67a.svg";
export { ForwardRef as ReactComponent };